import styled from 'styled-components';
export const Item = styled.div `
  line-height: 24px;
  height: 20px;
  margin-top: 4px;
`;
